import styled from 'styled-components';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';

/** Linha interna do card de interesses (duas colunas alinhadas ao topo). */
export const ComercialInterestInner = styled(StyledRow)`
  width: 100%;
  margin: 0;
  align-items: stretch;
  justify-content: flex-start;
`;
